import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getDBSummary } from '@/service/dashboard';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  data: {}
}

export const fetchDBSummary = createAsyncThunk(
  'dbSummary/fetchDBSummary',
  async ({query = {}}, {rejectWithValue}) => {
    try {
      const response = await getDBSummary(query);
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取全局完成率失败');
    }
  }
)

const dbSummaryTypeSlice = createSlice({
  name: 'dbSummaryType',
  initialState: defaultState,
  reducers: {
    resetDBSummaryTypeState: (state, action) => {
        const { serviceType } = action.payload || {};
        if (!serviceType) {
          Object.keys(state).forEach(key => {
            if (Array.isArray(state[key])) {
              state[key] = [];
            }
          });
          state.query = {};
        } else {
          // 重置指定服务类型的数据
          state[serviceType] = [];
          state.query[serviceType] = {};
  
        }
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchDBSummary.pending, (state, action) => {
          const arg = action.meta.arg || {};
          const { query = {} } = arg;
          state.fetching = true;
          state.error = null;
          state.query = query;
          state.data = {};
        })
        .addCase(fetchDBSummary.fulfilled, (state, action) => {
          const { data, query } = action.payload;
          state.fetching = false;
          state.error = null;
          state.data = data;
          state.query = query;
        })
        .addCase(fetchDBSummary.rejected, (state, action) => {
          state.fetching = false;
          state.error = action.payload;
          state.data = {};
          // 确保即使出错也不阻塞页面其他内容
          console.error('fetchDBSummary 请求失败:', action.payload);
        });
    }
  })

  export const { resetDBSummaryTypeState } = dbSummaryTypeSlice.actions;
  export const dbSummaryTypeSelectors = {}

  export default dbSummaryTypeSlice.reducer;